/* prettier-ignore */

type Result = { is_successful: true } | { is_successful: false; reason: string };

export function validateRoute(route, day): Result {
    if (!route?.length) 
        return { 
            is_successful: false, 
            reason: 'No hay ruta generada' 
        };

    const dayIndex = (Number(day) || 0) - 1;
    if (dayIndex < 0 || dayIndex >= route.length) 
        return { 
            is_successful: false, 
            reason: 'Día fuera de rango' 
        };

    return { 
        is_successful: true, 
    };
}

export function isNotSuccess(result){
    return result.is_successful === false;
}